import React from "react";
import { Router } from "@reach/router";
import GameMenu from "./GameMenu";
import Topics from "./Topics";
import Practice from "./Practice";
import MTCPractice from "./MTCPractice";
import SPATSPractice from "./SpellingSATsPractice";
import KS1Practice from "./KS1Practice";
import Rating from "./Rating";
import Multiplayer from "./Multiplayer";
import Endless from "./Endless";
import Learn from "./Learn";
import Duels from "./Duels";

export default function games() {
  return (
    <Router>
      <GameMenu path="/" />
      <Topics path="/topics" />
      <Practice path="/practise" />
      <Learn path="/learn" />
      <MTCPractice path="/MTCpractise" />
      <SPATSPractice path="/SpellingSATsPractice" />
      <KS1Practice path="/KS1Practice" />
      <Rating path="/rating" />
      <Multiplayer path = "/multiplayer"/>
      <Endless path="/endless"/>
      <Duels path="/duels"/>
    </Router>
  );
}
